import { useState } from "react";
import  "./AcidityLevel.css";


const AcidityLevel = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.aciditylevel===0?0:data.aciditylevel);

  function onChangeValue(event) {
    setVal(event.target.value);
    handleChange(event);
  }
    return (
  <div class="AcidityLevelCard" name="aciditylevel" onChange={onChangeValue}>
    <div class="AcidityLevel-rating-container">

      <div class="AcidityLevel-rating">
        <form class="AcidityLevel-rating-form-1" >

          <label for={`ACL1F-${count}`}>
            <input type="radio"  name="aciditylevel" class="AcidityLevel1" id={`ACL1F-${count}`}  value="6"  checked={'' + val === "6"} />
                <div className="aromacircle1"></div>
                <p>6</p>
           </label>

          <label for={`ACL2F-${count}`}>
              <input type="radio" name="aciditylevel" class="AcidityLevel2" id={`ACL2F-${count}`} value="6.25" checked={'' + val === "6.25"} />
                <div className="aromacircle2"></div>
               <p className="invisible">.5</p>
           </label>

          <label for={`ACL3F-${count}`}>
              <input type="radio" name="aciditylevel" class="AcidityLevel3" id={`ACL3F-${count}`} value="6.5" checked={'' + val === "6.5"} />
                <div className="aromacircle3"></div>
                <p className="invisible">.5</p>
            </label>

          <label for={`ACL4F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel4" id={`ACL4F-${count}`} value="6.75" checked={'' + val === "6.75"} />
               <div className="aromacircle4"></div>
               <p className="invisible">.5</p>

            </label>

          <label for={`ACL5F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel5" id={`ACL5F-${count}`} value="7" checked={'' + val === "7"} />
                <div className="aromacircle5"></div>
                <p>7</p>
             </label>
             {/* Didn't change it after this */}
             <label for={`ACL6F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel6" id={`ACL6F-${count}`} value="7.25" checked={'' + val === "7.25"} />
                <div className="aromacircle6"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL7F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel7" id={`ACL7F-${count}`} value="7.5" checked={'' + val === "7.5"} />
                <div className="aromacircle7"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL8F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel8" id={`ACL8F-${count}`} value="7.75" checked={'' + val === "7.75"} />
                <div className="aromacircle8"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL9F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel9" id={`ACL9F-${count}`} value="8" checked={'' + val === "8"} />
                <div className="aromacircle9"></div>
                <p>8</p>

             </label>

             <label for={`ACL10F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel10" id={`ACL10F-${count}`} value="8.25" checked={'' + val === "8.25"} />
                <div className="aromacircle10"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL11F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel11" id={`ACL11F-${count}`} value="8.5" checked={'' + val === "8.5"} />
                <div className="aromacircle11"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL12F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel12" id={`ACL12F-${count}`} value="8.75" checked={'' + val === "8.75"} />
                <div className="aromacircle12"></div>
                <p className="invisible">.5</p>
             </label>


             <label for={`ACL13F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel13" id={`ACL13F-${count}`} value="9" checked={'' + val === "9"} />
                <div className="aromacircle13"></div>

                <p>9</p>
             </label>

             <label for={`ACL14F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel14" id={`ACL14F-${count}`} value="9.25" checked={'' + val === "9.25"} />
                <div className="aromacircle14"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL15F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel15" id={`ACL15F-${count}`} value="9.5" checked={'' + val === "9.5"} />
                <div className="aromacircle15"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL16F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel16" id={`ACL16F-${count}`} value="9.75" checked={'' + val === "9.75"} />
                <div className="aromacircle16"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ACL17F-${count}`}>
             <input type="radio" name="aciditylevel" class="AcidityLevel17" id={`ACL17F-${count}`} value="10" checked={'' + val === "10"} />
                <div className="aromacircle17"></div>
                <p>10</p>
             </label>



        </form>
      </div>
    </div>
  </div>


    );
}

export default AcidityLevel;